export const CHAT_BOT_EVENT = "Chatbot";

export const CHAT_BOT_STEPS = {
  QUESTION_ASKED: "Asked Question"
};
